import React, { useState } from "react";
import { ChatState } from "../../Context/ChatProvider";
import { Box } from "@material-ui/core";
import ChatBox from "../Chat/ChatBox";
import MyChats from "../Chat/MyChats";
import SideDrawer from "../miscellaneous/SideDrawer";

const ChatPage = () => {
  const { user } = ChatState();
  const [fetchAgain, setFetchAgain] = useState(false);
  return (
    <div style={{ width: "100%" }}>
      {user && <SideDrawer />}
      <Box
        display="flex"
        justifyContent="space-between"
        width="100%"
        height="91.5vh"
        pt={1.5}
        sx={{ gap: "10px" }}
      >
        {user && <MyChats fetchAgain={fetchAgain} />}
        {user && (
          <ChatBox fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
        )}
      </Box>
    </div>
  );
};

export default ChatPage;
